var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('Rgrid',{attrs:{"gdata":_vm.gridData,"columns":_vm.gridColumns,"footer":_vm.gridfooter}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }